import { h, Fragment } from 'preact';
import htm from 'htm';
import { DashboardScreen } from './screens/DashboardScreen.js';
import { ScheduleScreen } from './screens/ScheduleScreen.js';
import { GroupsScreen } from './screens/GroupsScreen.js';
import { SessionsScreen } from './screens/SessionsScreen.js';
import { CardsScreen } from './screens/CardsScreen.js';
import { SettingsScreen } from './screens/SettingsScreen.js';
import { Modals } from './Modals.js';

const html = htm.bind(h);

export function AppContent() {
    return html`
        <${Fragment}>
            <${DashboardScreen} />
            <${ScheduleScreen} />
            <${Modals} />
            <${GroupsScreen} />
            <${SessionsScreen} />
            <${CardsScreen} />
            <${SettingsScreen} />
        </${Fragment}>
    `;
}
